import { environment } from './../../environments/environment';

export const AB_REFRESH_SESSION_TIME = 2; // minutes
export const AB_SHOW_SESSION_EXPIRY_POPUP = 20; // minutes
export const AB_ACCESS_DENIED_REDIRECT_INTERVAL = 5000; // Milliseconds

export const AB_API_DOMAIN = environment.apiDomain || '';
export const AB_API_BASE = '/api/v2';

export const NEW_MASHUP_URL = environment.newPegaMashupScriptUrl;

export const AB_API_LOGIN = '/account/login';
export const AB_API_QRCODE = '/account/deviceless';
export const AB_API_QRCODE_STATUS = '/account/deviceless/status';
export const AB_API_INITIAL_VIEW = '/account/initialview';

export const AB_API_USER_MANAGEMENT = '/usermanagement';
export const AB_API_USER_MANAGEMENT_OVERVIEW_URL =
  '/useraccessmanagement/usersoverview';
export const AB_API_PORTFOLIO_USERS_DETAILS = '/usermanagement/details';
export const AB_API_SET_DEFAULT_PORTFOLIO =
  '/usermanagement/setdefaultportfolio';

export const AB_API_REQUEST_LOGIN_TOOL = '/requestlogintool/send';

export const AB_API_PORTFOLIO_USERS_ENDPOINT = '/getportfoliousers';
export const AB_API_PORTFOLIO_ACCOUNT_MANAGER = '/personaldetails/managerinfo';

export const AB_API_EXCHANGE_RATES_ENDPOINT = '/exchangerates/getexchangerates';

export const AB_API_ACCOUNTSOVERVIEW_ENDPOINT =
  '/JSSTBAccounts/getaccountoverview';
export const AB_API_LOCAL_FROM_ACCOUNTS_ENDPOINT =
  '/JSSTBAccounts/localFromAccounts';
export const AB_API_FROM_ACCOUNTS_BULK_ENDPOINT =
  '/JSSTBAccounts/fromAccounts/bulk';
export const AB_API_INTERNATIONAL_FROM_ACCOUNTS_ENDPOINT =
  '/JSSTBAccounts/internationalFromAccounts';
export const AB_API_ACCOUNTS_FOR_CLOSING =
  '/JSSTBAccounts/eligibleforclosingaccounts';
export const AB_API_OVERDRAFTS = '/JSSTBAccounts/overdrafts';
export const AB_API_GETACCOUNTDETAILS = '/JSSTBAccounts/getaccountdetails';
export const AB_API_FULL_PORTFOLIO_VIEW = '/JSSTBAccounts/fullportfolioview';

export const AB_API_GET_CREDITCARDS = '/creditcard';
export const AB_API_GET_CREDITCARD_TRANSACTIONS = '/creditcard/transactions';

export const AB_API_USER_BANKACCOUNTS_SETTINGS = '/user/bankaccounts/settings';

export const AB_API_REFRESH_SESSION = '/general/refreshsession';
export const AP_API_CHECK_ROUTE_ACCESS = '/general/checkrouteaccess';
export const AB_API_PORTFOLIO = '/general/portfolio';
export const AB_API_PORTFOLIO_DEFAULT = '/general/portfolio/default';
export const AB_API_GET_CHALLENGE = '/general/challenge';

export const AB_API_SENTOO_PAYMENT_DETAILS = '/sentoo/paymentdetails/get';
export const AB_API_SENTOO_CANCEL = '/sentoo/cancel';
export const AB_API_SENTOO_CREATE = '/sentoo/create';
export const AB_API_SENTOO_APPROVE = '/sentoo/approve';
export const AB_API_SENTOO_STATUS = '/sentoo/status';
export const AB_API_SENTOO_QRCODE = '/sentoo/qrcode/get';
export const AB_API_SENTOO_ACCOUNTS = '/sentoo/accounts/get';

export const AB_SENTOO_TRANSFER = '/sentootransfer';
export const AB_SENTOO = '/sentoo';

export const AB_API_TRANSACTION_ACCOUNT = '/transactionaccount/get';

export const AB_API_TRANSACTION_OVERVIEW = '/transactionoverview/get';

export const AB_API_TRANSACTION_SEARCH = '/transactionsearch/transactions';
export const AB_API_BLOCK_BANK_ACCOUNT = '/blockbankaccount/accounts';
export const AB_API_TRANSACTION_DOWNLOAD = '/downloadtransactions/get';
export const AB_API_TRANSACTION_STATEMENTS = '/statements';

export const AB_API_TRANSFERS_SUBMITTED = '/transfers/submitted';
export const AB_API_TRANSFERS_SUBMITTED_DETAIL = '/transfers/submitted/detail';
export const AB_API_TRANSFERS_REJECTED_ONETIME =
  '/transfers/rejected/onetime/default';
export const AB_API_TRANSFERS_REJECTED_ONETIME_FULL =
  '/transfers/rejected/onetime/full';
export const AB_API_TRANSFERS_REJECTED_RECURRING =
  '/transfers/rejected/recurring/default';
export const AB_API_TRANSFERS_REJECTED_RECURRING_FULL =
  '/transfers/rejected/recurring/full';
export const AB_API_BULK_TRANSFERS_REJECTED =
  '/transfers/rejected/bulk/default';
export const AB_API_BULK_TRANSFERS_REJECTED_FULL =
  '/transfers/rejected/bulk/full';
export const AB_API_TRANSFERS_COUNTRYLIST = '/transfers/countrylist';

export const AB_API_TRANSFERS_GETBANKSBYCOUNTRY =
  '/transfers/getBanksByCountry';
export const AB_API_REFERENCE_CODES = '/transfers/referencecodes';
export const AB_API_BILL_PAYEE_ATTRIBUTES = '/transfers/billpayee';
export const AB_API_TRANSFERS_TO_ACCOUNTS = '/transfers/toaccounts';
export const AB_API_TRANSFERS_TO_BENEFICIARIES =
  '/transfers/toaccounts/beneficiaries';
export const AB_API_TRANSFERS_SUBMIT = '/transfers/submit';
export const AB_API_TRANSFERS_SCHEDULED = '/transfers/scheduled';
export const AB_API_TRANSFERS_SCHEDULED_BULK = '/transfers/scheduled/bulk';
export const AB_API_TRANSFERS_VALIDATE = '/transfers/validate';
export const AB_API_BANK_BY_BIC = '/transfers/bankByBIC';
export const AB_API_TRANSFERS_BULK_VALIDATE = '/transfers/bulk/validate';
export const AB_API_TRANSFERS_BULK_UPLOAD = '/transfers/bulk/upload';
export const AB_API_TRANSFERS_BULK_DOMESTIC = '/transfers/bulk/domestic';
export const AB_API_TRANSFERS_BULK_INTERNATIONAL =
  '/transfers/bulk/international';
export const AB_API_DAILY_LIMIT = '/transfers/dailylimit';

export const AB_API_PAYMENTS_PENDING_TRANSFERS_COUNT =
  '/basket/payments/GetPendingTransfersCount';
export const AB_API_TRANSFERS_PENDING = '/basket/payments';
export const AB_API_TRANSFERS_DELETE = '/basket/delete';
export const AB_API_TRANSFERS_GET_TRANSFER = '/basket/payment';
export const AB_API_GET_CHALLENGE_BASKET = '/basket/challenge';
export const AB_API_TRANSFERS_APPROVE = '/basket/submit';
export const AB_API_PAYMENT_BULK_DOMESTIC = '/basket/payment/bulk/domestic';
export const AB_API_PAYMENT_BULK_INTERNATIONAL =
  '/basket/payment/bulk/international';
export const AB_API_BULK_VIEW_STATUS = '/basket/payments/bulk';
export const AB_API_BULK_DETAILS = '/basket/payment/bulk';
export const AB_API_BULK_REJECT = '/basket/reject';
export const AB_API_BASKET_REJECT = '/basket/payment/reject';
export const AB_API_BASKET_CHECK_PAYMENTS = '/basket/checkpayments';

export const AB_API_ADDRESSBOOK = '/addressbook';
export const AB_API_ADDRESSBOOK_COMPANIES = '/addressbook/companies';
export const AB_API_ADDRESSBOOK_BENEFICIARIES = '/addressbook/beneficiaries';
export const AB_API_ADDRESSBOOK_ADDRESS = '/addressbook/address';

export const AB_API_REPORTING_TABLE = '/reporting/table';
export const AB_API_REPORTING_DOWNLOAD = '/reporting/download';
export const AB_API_TEXTBANKING_SEND = '/textbanking/send';
export const AB_API_TEXTBANKING_INFO = '/textbanking/info';
export const AB_API_ATMPINCODE_INFO = '/personaldetails/residentialaddress';
export const AB_API_ATMPINCODE_SEND = '/atmpincode/send';
export const AB_API_LINK_ATM_CARD = '/linkatmcard/atmcards';
export const AB_API_REQUEST_APP = '/requestapp/send';
export const AB_API_DOWNLOAD_DOCUMENTS = '/download/documents';
export const AB_API_PERSONALARCHIVE_PRIVATE_DOCUMENTS =
  '/personalarchive/documents';
export const AB_API_PERSONALARCHIVE_INTEREST_LETTERS =
  '/personalarchive/interestletter';
export const AB_API_PERSONALARCHIVE_MESSAGES = '/personalarchive/messages';
export const AB_API_PERSONALARCHIVE_MARKASREAD =
  '/personalarchive/message/makrasread';
export const AB_API_PERSONALARCHIVE_MESSAGES_COUNT =
  '/personalarchive/message/count';

export const AB_API_CLOSE_ACCOUNT = '/closebankaccount/account';
export const AB_API_MASHUP_ENDPOINT = '/mashup/token';
export const AB_API_CONTACTUS_DATA = '/contactus/data';

export const AB_LOGIN_FORM_URL = '/';
export const AB_DASHBOARD_URL = '/dashboard/';

export const AB_ADDRESSBOOK_URL = '/addressbook/addressbook/';
export const AB_ADDRESSBOOK_ADD = '/addressbook/address';

export const AB_GET_BANK_CARDS = '/bankcard/all';
export const AB_BLOCK_BANK_CARD = '/bankcard/block';

export const AB_GET_MOBILE_DEVICES = '/mobiledevices/getlist';
export const AB_DISCONNECT_MOBILE_DEVICES = '/mobiledevices/disconnectdevice';

export const AB_OVERDRAFTSLIMITS = '/bankaccountoverdrafts/overdraftslimits';
export const AB_OVERDRAFTSTEPDETAILS =
  '/bankaccountoverdrafts/overdraftstepdetails';
export const AB_OVERDRAFTSUBMIT = '/bankaccountoverdrafts/submit';

export const AB_TRANSACTION_PRINT = '/transactions/printtransactions';

export const AB_DATE_PREVENT_REGEX = '[^0-9/]';
export const AB_PHONE_NUMBER_PATTERN = '^(\\+)?(\\d{5,15})$';
export const AB_EMAIL_PATTERN =
  '^[\\w!#$%&*+\\-/=?\\^_`{|}~]+(\\.[\\w!#$%&*+\\-/=?\\^_`{|}~]+)*@((([\\-\\w]+\\.)+[a-zA-Z]{2,4})|(([0-9]{1,3}\\.){3}[0-9]{1,3}))$';
export const AB_DATE_FORMAT_FULL = 'MM/dd/yyyy';
export const AB_DATE_MOMENT_FORMAT = 'MM/DD/YYYY';
export const AB_DATE_FORMAT_SHORT = 'yyyy-M-d';
export const AB_CURRENCY_FORMAT = '1.2-2';
export const AB_CURRENCY_FORMAT_AMOUNT = '1.0-0';
export const AB_LOGIN_NAME_PATTERN =
  '^[a-zA-Z0-9\\-:, .;@ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜ¢£ƒáíóúñÑÁÀÏÍÌÈËÓÒÚÙ€ ]+$';
export const AB_LOGIN_USERNAME_PATTERN = '^[a-zA-Z0-9_\\-.@]{8,20}$';
